function escapeHtmlAttr(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeHtmlContent(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export default function convertLinksToAnchors(metin) {
  if (!metin) return '';

  // URL'leri bulmak için düzenli ifade - only allow safe protocols (http, https, ftp, file)
  var urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

  // URL'leri HTML linklerine dönüştür
  return metin.replace(urlRegex, function (url) {
    // Block javascript: protocol URLs (defense in depth)
    var lowerUrl = url.toLowerCase().trim();
    if (lowerUrl.indexOf('javascript:') === 0) {
      return escapeHtmlContent(url);
    }
    return '<a href="' + escapeHtmlAttr(url) + '" target="_blank" rel="noopener noreferrer">' + escapeHtmlContent(url) + '</a>';
  });
}



// WEBPACK FOOTER //
// ./src/helpers/convertLinksToAnchors.js